import { isEmpty } from "lodash-es";

import RouteDetail from "@mapmycustomers/shared/types/entity/RouteDetail";

// Whether the route ends somewhere other than its last stop — which is what decides whether the
// stored leg array carries a trailing entry. The BE's projection gate turns on exactly this
// answer (`legs === stops + 1` with an end location, `legs === stops` without — one or the
// other, never either), so the send side has to agree with it. Mirrors the server's own
// predicate: an entity end is `{}` rather than null on a manual route, so emptiness is checked
// rather than presence.
const hasRouteEndLocation = (
  routeDetail: Partial<Pick<RouteDetail, "endAddress" | "endEntity" | "endGeoPoint">>
): boolean =>
  routeDetail.endAddress != null ||
  routeDetail.endGeoPoint != null ||
  !isEmpty(routeDetail.endEntity);

export default hasRouteEndLocation;
